import { CommandRequestType } from "../connection/commandRequestType";
import { ICommandParameters } from "../connection/iCommandParameters";
import { ICommandResponse } from "../connection/iCommandResponse";
import { IRequestCommand } from "../connection/iRequestCommand";
import { ErrorDetails } from "../connection/interfaces/apiInterfaces";

export class GetAdminInfoCommand extends IRequestCommand<
  IGetAdminInfoResponse,
  ErrorDetails,
  IGetAdminInfoCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'admins/byUser/{adminUserId}';
  public override setParameters(parameters: IGetAdminInfoCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{adminUserId}',
      parameters.adminUserId
    );
  }
}

export interface IGetAdminInfoCommandParameters extends ICommandParameters {
  adminUserId: string;
}

export interface IGetAdminInfoResponse extends ICommandResponse {}
